import { render, staticRenderFns } from "./bimButton.vue?vue&type=template&id=644bc4a4&scoped=true&"
import script from "./bimButton.vue?vue&type=script&lang=js&"
export * from "./bimButton.vue?vue&type=script&lang=js&"
import style0 from "./bimButton.vue?vue&type=style&index=0&id=644bc4a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644bc4a4",
  null
  
)

export default component.exports